const stripHtmlComments = str => {
  if (typeof str !== 'string') {
    throw new TypeError('strip-html-comments expected a string');
  }
  return str.replace(/<!--[\s\S]*?(?:-->)/g, '');
};

export default stripHtmlComments;
